import app from 'flarum/forum/app';
import ForumModalModal from '../components/ForumModalModal';
export default async function showModalsOnLoad() {
  if (!app.session.user) return;
  const modals = await app.store.find('modals');
  if (!modals?.length) return;
  for (const modal of modals) {
    if (!modal.shouldShow()) continue;
    const ModalClass = classFor(modal);
    app.modal.show(ModalClass, {
      modal: modal
    });
    await afterShowSettled();
    await waitForModalClosed();
    await waitForBackdropGone();
  }
}
const nextFrame = () => new Promise(resolve => requestAnimationFrame(() => resolve()));
const afterShowSettled = () => nextFrame().then(nextFrame);
const waitForModalClosed = () => new Promise(resolve => {
  const tick = () => app.modal.isModalOpen() ? requestAnimationFrame(tick) : requestAnimationFrame(() => resolve());
  tick();
});
const waitForBackdropGone = () => new Promise(resolve => {
  const tick = () => document.querySelector('.Modal-backdrop.backdrop') ? requestAnimationFrame(tick) : requestAnimationFrame(() => resolve());
  tick();
});
function classFor(modal) {
  const viaCloseButton = modal.dismissibleCloseBtn();
  const viaEscKey = modal.dismissibleEscKey();
  const viaBackdropClick = modal.dismissibleBackdropClick();
  return class DynamicModalModal extends ForumModalModal {
    static get dismissibleOptions() {
      return {
        viaCloseButton,
        viaEscKey,
        viaBackdropClick
      };
    }
  };
}
flarum.reg.add('glowingblue-modals', 'forum/extenders/showModalsOnLoad', showModalsOnLoad);